import React from 'react';

import loginPageCss from "../../register/css/loginPage.module.css";

import Alert from "../../../component/modal/Alert";
import Loading from "../../../component/loading/Loading";
import RadioBtnList from "../../../component/input/RadioBtnList";

import AuthToChangeInfoModal from "../modal/AuthToChangeInfoModal";
import ChangePasswordModal from "../modal/ChangePasswordModal";
import CouponListModal from "../modal/CouponListModal";
import BussinessFileModal from "../modal/BussinessFileModal";
import UpdateCateModal from "../../../component/modal/UpdateCateModal";
import PhoneRegisterModal from "../modal/PhoneRegisterModal";
import PhoneListModal from "../modal/PhoneListModal";
import PhoneUpdateModal from "../modal/PhoneUpdateModal";
import WithdrawModal from "../modal/WithdrawModal";
import MarketingAgreeHistoryModal from "../modal/MarketingAgreeHistoryModal";
import AppRequestListModal from "../../../component/modal/AppRequestListModal";
import AppRequestModal from "../../../component/modal/AppRequestModal";

import * as stringUtil from '../../../util/stringUtil';
import * as apiUtil from "../../../util/apiUtil";
import * as dateUtil from "../../../util/dateUtil";
import * as tokenUtil from "../../../util/tokenUtil";

import * as myInfoAction from "../store/myInfo";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

export const agreement = [
    { label: '동의함', value: 'Y' },
    { label: '동의안함', value: 'N' },
];

class MyPageContainer extends React.Component {
    constructor(props) {
        super(props);

        this.setLoading = this.setLoading.bind(this);
        this.setValue = this.setValue.bind(this);
        this.setRivalCompanyUrl = this.setRivalCompanyUrl.bind(this);
        this.setInputRivalCompanyUrl = this.setInputRivalCompanyUrl.bind(this);
        this.setPhoneRegisterInfo = this.setPhoneRegisterInfo.bind(this);

        this.ajaxGetUserInfo = this.ajaxGetUserInfo.bind(this);
        this.ajaxPostProfileImage = this.ajaxPostProfileImage.bind(this);
        this.ajaxPostPhoneReady = this.ajaxPostPhoneReady.bind(this);

        this.openAlert = this.openAlert.bind(this);
        this.closeAlert = this.closeAlert.bind(this);

        this.submitAuthForm = this.submitAuthForm.bind(this);

        this.ajaxAddRivalCompanyUrl = this.ajaxAddRivalCompanyUrl.bind(this);
        this.ajaxUpdateRivalCompanyUrl = this.ajaxUpdateRivalCompanyUrl.bind(this);
        this.ajaxDeleteRivalCompanyUrl = this.ajaxDeleteRivalCompanyUrl.bind(this);
        this.ajaxRegisterPhoneNumber = this.ajaxRegisterPhoneNumber.bind(this);
        this.ajaxGetPhoneNumberList = this.ajaxGetPhoneNumberList.bind(this);
        this.ajaxDeletePhoneNumber = this.ajaxDeletePhoneNumber.bind(this);
        this.ajaxGetPhoneNumberForUpdate = this.ajaxGetPhoneNumberForUpdate.bind(this);
        this.ajaxUpdatePhoneNumber = this.ajaxUpdatePhoneNumber.bind(this);

        this.handlePhoneListPageChange = this.handlePhoneListPageChange.bind(this);

        this.ajaxGetWebAppList = this.ajaxGetWebAppList.bind(this);

        this.handleWebappListPageChange = this.handleWebappListPageChange.bind(this);
        this.handleWebappRequestModal = this.handleWebappRequestModal.bind(this);
        this.ajaxWithdraw = this.ajaxWithdraw.bind(this);

        this.state = {
            loading: false,

            businessFile: false,
            changeAuth: false,
            changePass: false,
            couponList: false,
            changeCate: false,
            phoneRegister: false,
            phoneListModal: false,
            phoneUpdateModal: false,
            phoneUpdateOriginalList: [],
            webappListModal: false,
            webappRequestModal: false,
            withdrawModal: false,
            marketingAgreeHistory: false,

            alertOpen: false,
            alertMessage: '',
            alertButtons: [],

            TID: '',
        };
    }

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        return (
            this.state.loading !== nextState.loading
            || this.state.businessFile !== nextState.businessFile
            || this.state.changeAuth !== nextState.changeAuth
            || this.state.changePass !== nextState.changePass
            || this.state.couponList !== nextState.couponList
            || this.state.changeCate !== nextState.changeCate
            || this.state.phoneRegister !== nextState.phoneRegister
            || this.state.phoneListModal !== nextState.phoneListModal
            || this.state.phoneUpdateModal !== nextState.phoneUpdateModal
            || this.state.webappListModal !== nextState.webappListModal
            || this.state.webappRequestModal !== nextState.webappRequestModal
            || this.state.withdrawModal !== nextState.withdrawModal
            || this.state.marketingAgreeHistory !== nextState.marketingAgreeHistory
            || this.state.alertOpen !== nextState.alertOpen
            || this.state.TID !== nextState.TID
            || this.props.user !== nextProps.user
            || this.props.rivalCompanyUrls !== nextProps.rivalCompanyUrls
            || this.props.inputRivalCompanyUrl !== nextProps.inputRivalCompanyUrl
            || this.props.coupons !== nextProps.coupons
            || this.props.phoneRegisterName !== nextProps.phoneRegisterName
            || this.props.phoneRegisterList !== nextProps.phoneRegisterList
            || this.props.phoneListPage !== nextProps.phoneListPage
            || this.props.phoneListSize !== nextProps.phoneListSize
            || this.props.phoneListTotal !== nextProps.phoneListTotal
            || this.props.phoneList !== nextProps.phoneList
            || this.props.phoneUid !== nextProps.phoneUid
            || this.props.webappListPage !== nextProps.webappListPage
            || this.props.webappListSize !== nextProps.webappListSize
            || this.props.webappListTotal !== nextProps.webappListTotal
            || this.props.webappList !== nextProps.webappList

            || this.props.businessFile !== nextProps.businessFile
        );
    }

    componentDidMount() {
        this.ajaxGetUserInfo();
    }

    setLoading(loading) {
        this.setState({ loading: loading });
    }

    openAlert(message, buttons) {
        this.setState({ alertOpen: true, alertMessage: message, alertButtons: buttons });
    }
    closeAlert() {
        const { alertOpen } = this.state;
        this.setState({ alertOpen: !alertOpen });
    }

    // 마케팅 수신 동의 변경 사항 수정
    setValue(id, value) {
        if (!window.confirm("마케팅 수신 동의 상태를 변경하시겠습니까?")) {
            return;
        }

        const { user } = this.props;

        let agreeRecvMms;
        let agreeRecvMail;
        let agreeRecvKakao = user.agreeRecvKakao || 'N';

        switch (id) {
            case "agreeRecvMms":
                agreeRecvMms = value;
                agreeRecvMail = user.agreeRecvMail;
                break;
            case "agreeRecvMail":
                agreeRecvMms = user.agreeRecvMms;
                agreeRecvMail = value;
                break;
            case "agreeRecvKakao":
                agreeRecvMms = user.agreeRecvMms;
                agreeRecvMail = user.agreeRecvMail;
                agreeRecvKakao = value;
                break;
        }

        apiUtil.asyncRequest({
            setLoading: this.setLoading,
            url: `/api/bizchat/user/agreement/update`,
            method: apiUtil.requestMethod.POST,
            data: {
                agreeRecvMms: agreeRecvMms,
                agreeRecvMail: agreeRecvMail,
                agreeRecvKakao: agreeRecvKakao,
            },
            success: (result) => {
                const agreed = value === 'Y';
                const channelInfo = {
                    agreeRecvMms: { name: '문자', agreedAt: result.mmsAgreedAt, revokedAt: result.mmsRevokedAt },
                    agreeRecvMail: { name: '이메일', agreedAt: result.mailAgreedAt, revokedAt: result.mailRevokedAt },
                    agreeRecvKakao: { name: '카카오톡', agreedAt: result.kakaoAgreedAt, revokedAt: result.kakaoRevokedAt },
                }[id];
                const channel = channelInfo.name;
                const processedAt = agreed ? channelInfo.agreedAt : channelInfo.revokedAt;
                alert(`비즈팅에서 알려드립니다.\n\n${channel} 마케팅 수신 ${agreed ? '동의' : '철회'}가 처리되었습니다.\n처리 일시: ${processedAt || '-'}\n\n※ 동의 상태는 [마이페이지 > 마케팅 수신 동의]에서 변경할 수 있습니다.`);
                window.location.reload();
            }
        })
    }

    setRivalCompanyUrl(id, value) {
        const { MyInfoAction } = this.props;
        const index = id.split('_')[1];
        MyInfoAction.updateRivalCompanyUrl({ index: index, value: value });
    }

    setInputRivalCompanyUrl(id, value) {
        const { MyInfoAction } = this.props;
        MyInfoAction.setInputRivalCompanyUrl(value);
    }

    setPhoneRegisterInfo(id, value) {
        const { MyInfoAction } = this.props;

        switch (id) {
            case "phoneName":
                const name = stringUtil.removeSpecialLetter(value);
                MyInfoAction.setPhoneRegisterName(name);
                break;
            case "phoneNumber0":
            case "phoneNumber1":
            case "phoneNumber2":
            case "phoneNumber3":
            case "phoneNumber4":
            case "phoneNumber5":
            case "phoneNumber6":
            case "phoneNumber7":
            case "phoneNumber8":
            case "phoneNumber9":
                const index = id.substr(-1, 1);
                const phone = stringUtil.pureNumber(value);
                MyInfoAction.setPhoneRegisterList({ index: index, value: phone });
                break;
        }
    }

    //ajax request methods
    ajaxGetUserInfo() {
        apiUtil.asyncRequest({
            setLoading: this.setLoading,
            url: "/api/bizchat/user/info",
            method: apiUtil.requestMethod.POST,
            success: (result) => {
                const { MyInfoAction } = this.props;
                MyInfoAction.setUser(result);
                MyInfoAction.setRivalCompanyUrls(result.rivalCompanyUrl);
                MyInfoAction.setCoupons(result.couponList);
            }
        })
    }
    ajaxPostProfileImage(event) {
        if (!window.confirm("프로필 이미지를 변경하시겠습니까?")) return;

        let data = new FormData();
        data.append('profileImg', event.target.files[0]);

        apiUtil.asyncRequest({
            setLoading: this.setLoading,
            url: "/api/bizchat/user/upload/image",
            method: apiUtil.requestMethod.POST,
            isFile: true,
            data: data,
            success: async (result) => {
                alert("프로필 이미지가 변경되었습니다.");
                await this.ajaxGetUserInfo();
            }
        })
    }

    // 다날 phone Ready
    ajaxPostPhoneReady() {
        apiUtil.asyncRequest({
            url: `/api/bizchat/user/phone/ready?purpose=phone_verify`,
            method: apiUtil.requestMethod.POST,
            success: (result) => {
                this.setState({ TID: result }, () => this.submitAuthForm());
            }
        })
    }
    submitAuthForm() {
        alert("등록된 담당자의 전화번호로 인증 부탁드립니다.");
        const form = document.getElementById('authForm');
        const formData = new FormData(form);

        // 팝업창 열기
        const popup = window.open('', '_blank', 'width=400,height=600');
        const formAction = form.getAttribute('action');

        popup.document.open();
        popup.document.write(`
            <html>
            <head><title>폼 제출 결과</title></head>
            <body>
                <form action="${formAction}" method="POST" target="_self">
                    ${Array.from(formData.entries()).map(([name, value]) => `
                        <input type="hidden" name="${name}" value="${value}" />
                    `).join('')}
                    <button type="submit">Submit</button>
                </form>
                <script>
                    document.forms[0].submit();
                </script>
            </body>
            </html>
        `);
        popup.document.close();

        const checkPopupClosed = setInterval(() => {
            if (popup.closed) {
                apiUtil.asyncRequest({
                    url: `/api/bizchat/user/verify/phone?TID=${this.state.TID}`,
                    method: apiUtil.requestMethod.POST,
                    success: (result) => {
                        if (result) this.setState({ changeCate: true });
                    }
                })
                clearInterval(checkPopupClosed);
            }
        }, 1000);
    }

    ajaxAddRivalCompanyUrl() {
        if (!window.confirm("경쟁업체 URL을 추가하시겠습니까?")) {
            return false;
        }

        const { MyInfoAction, rivalCompanyUrls, inputRivalCompanyUrl } = this.props;
        const newUrlArray = rivalCompanyUrls;
        rivalCompanyUrls.push(inputRivalCompanyUrl);

        apiUtil.asyncRequest({
            url: `/api/bizchat/user/urls/update`,
            method: apiUtil.requestMethod.POST,
            data: {
                rivalCompanyUrl: newUrlArray
            },
            success: (result) => {
                alert("경쟁업체 URL 정보가 변경되었습니다.");
                MyInfoAction.setInputRivalCompanyUrl("https://");
                this.ajaxGetUserInfo();
            }
        });
    }

    ajaxUpdateRivalCompanyUrl() {
        if (!window.confirm("경쟁업체 URL 정보를 변경하시겠습니까?")) {
            return false;
        }

        const { rivalCompanyUrls } = this.props;

        apiUtil.asyncRequest({
            url: `/api/bizchat/user/urls/update`,
            method: apiUtil.requestMethod.POST,
            data: {
                rivalCompanyUrl: rivalCompanyUrls
            },
            success: (result) => {
                alert("경쟁업체 URL 정보가 변경되었습니다.");
                this.ajaxGetUserInfo();
            }
        });
    }

    ajaxDeleteRivalCompanyUrl(rivalCompanyUrl) {
        if (!window.confirm("경쟁업체 URL 정보를 삭제하시겠습니까?")) {
            return false;
        }

        const { rivalCompanyUrls } = this.props;
        const newUrlArray = [];
        rivalCompanyUrls.map((item, index) => {
            if (item !== rivalCompanyUrl) {
                newUrlArray.push(item);
            }
        })

        apiUtil.asyncRequest({
            url: `/api/bizchat/user/urls/update`,
            method: apiUtil.requestMethod.POST,
            data: {
                rivalCompanyUrl: newUrlArray
            },
            success: (result) => {
                alert("경쟁업체 URL 정보가 변경되었습니다.");
                this.ajaxGetUserInfo();
            }
        });
    }

    ajaxRegisterPhoneNumber() {
        if (!window.confirm("전화번호를 등록하시겠습니까?")) return;

        const { phoneRegisterName, phoneRegisterList } = this.props;

        let list = phoneRegisterList.filter(item => item);

        apiUtil.asyncRequest({
            url: `/api/bizchat/user/phone/create`,
            method: apiUtil.requestMethod.POST,
            data: {
                name: phoneRegisterName,
                list: list,
            },
            success: (result) => {
                alert("전화번호가 등록되었습니다.");
                this.toggleModal('phoneRegister', false);

                const { MyInfoAction } = this.props;
                MyInfoAction.initPhoneRegister("");
            }
        });
    }

    ajaxGetPhoneNumberList() {
        const { phoneListPage, phoneListSize } = this.props;

        apiUtil.asyncRequest({
            url: `/api/bizchat/user/phone/list`,
            method: apiUtil.requestMethod.POST,
            data: {
                page: phoneListPage,
                size: phoneListSize,
            },
            success: (result) => {
                const { MyInfoAction } = this.props;
                MyInfoAction.setPhoneList(result.content);
                MyInfoAction.setPhoneListTotal(result.total);
            }
        });
    }

    ajaxUpdatePhoneNumber(uid) {
        if (!window.confirm("전화번호를 수정하시겠습니까?")) return;

        const { phoneRegisterName, phoneRegisterList } = this.props;
        const { phoneUpdateOriginalList } = this.state;
        let list = phoneRegisterList
            .slice(0, 10)
            .concat(phoneUpdateOriginalList.slice(10))
            .filter(item => item);

        apiUtil.asyncRequest({
            url: `/api/bizchat/user/phone/update/${uid}`,
            method: apiUtil.requestMethod.POST,
            data: {
                name: phoneRegisterName,
                list: list,
            },
            success: (result) => {
                alert("전화번호가 수정되었습니다.");

                const { MyInfoAction } = this.props;
                MyInfoAction.initPhoneRegister("");
                this.setState({ phoneUpdateOriginalList: [] });

                this.toggleModal('phoneUpdateModal', false);
            }
        });
    }

    async handlePhoneListPageChange(event, value) {
        const { MyInfoAction } = this.props;

        await MyInfoAction.setPhoneListPage(value);
        this.ajaxGetPhoneNumberList();
    }

    ajaxDeletePhoneNumber(uid) {
        if (!window.confirm("전화번호를 삭제하시겠습니까?")) return;

        apiUtil.asyncRequest({
            url: `/api/bizchat/user/phone/delete/${uid}`,
            method: apiUtil.requestMethod.POST,
            success: (result) => {
                alert("전화번호가 삭제되었습니다.");
                this.ajaxGetPhoneNumberList();
            }
        });
    }

    ajaxGetPhoneNumberForUpdate(uid) {
        const { MyInfoAction } = this.props;
        MyInfoAction.initPhoneRegister("");
        this.setState({ phoneUpdateOriginalList: [] });

        apiUtil.asyncRequest({
            url: `/api/bizchat/user/phone/${uid}`,
            method: apiUtil.requestMethod.POST,
            success: (result) => {
                this.setState({ phoneUpdateOriginalList: result.list || [] });
                MyInfoAction.setPhoneUid(result.uid)
                MyInfoAction.setPhoneRegisterName(result.name);
                if (result.list) {
                    result.list.forEach((item, index) => {
                        MyInfoAction.setPhoneRegisterList({ index: index, value: item });
                    });
                }
            }
        });
    }

    ajaxGetWebAppList() {
        const { webappListPage, webappListSize } = this.props;

        apiUtil.asyncRequest({
            url: `/api/category/ats/webapp/request/list`,
            method: apiUtil.requestMethod.POST,
            data: {
                page: webappListPage,
                size: webappListSize,
            },
            success: (result) => {
                const { MyInfoAction } = this.props;
                MyInfoAction.setWebappList(result.content);
                MyInfoAction.setWebappListTotal(result.total);
            }
        });
    }

    // 공통 모달 상태 토글 메소드
    toggleModal(modalName, value) {
        const { MyInfoAction } = this.props;

        if (modalName === 'phoneRegister' && value === true) {
            MyInfoAction.initPhoneRegister("");
            this.setState({ phoneUpdateOriginalList: [] });
        } else if ((modalName === 'phoneRegister' || modalName === 'phoneUpdateModal') && value === false) {
            MyInfoAction.initPhoneRegister("");
            this.setState({ phoneUpdateOriginalList: [] });
        }

        this.setState({ [modalName]: value });

        if (modalName === 'phoneListModal' && value === true) {
            this.ajaxGetPhoneNumberList();
        } else if (modalName === 'webappListModal' && value === true) {
            this.ajaxGetWebAppList();
        }
    }

    async handleWebappListPageChange(event, value) {
        const { MyInfoAction } = this.props;

        await MyInfoAction.setWebappListPage(value);
        this.ajaxGetWebAppList();
    }

    handleWebappRequestModal() {
        const { webappRequestModal } = this.state;
        this.setState({ webappRequestModal: !webappRequestModal });
    }

    ajaxWithdraw(data) {
        apiUtil.asyncRequest({
            setLoading: this.setLoading,
            url: "/api/bizchat/user/withdraw",
            method: apiUtil.requestMethod.POST,
            data: data,
            success: () => {
                // 탈퇴 API 성공 후에만 토큰과 사용자 캐시를 정리합니다.
                tokenUtil.clearAuthStorage();
                alert("회원 탈퇴가 완료되었습니다.");
                window.location.href = "/account/login";
            }
        });
    }

    render() {
        const { loading } = this.state;

        const {
            user, coupons, rivalCompanyUrls, inputRivalCompanyUrl,
            phoneRegisterName, phoneRegisterList,
            phoneListPage, phoneListSize, phoneListTotal, phoneList, phoneUid,
            webappListPage, webappListSize, webappListTotal, webappList
        } = this.props;
        const {
            setValue, setRivalCompanyUrl, setInputRivalCompanyUrl, setPhoneRegisterInfo,
            ajaxAddRivalCompanyUrl, ajaxUpdateRivalCompanyUrl, ajaxDeleteRivalCompanyUrl,
            ajaxRegisterPhoneNumber, handlePhoneListPageChange, ajaxDeletePhoneNumber, ajaxGetPhoneNumberForUpdate, ajaxUpdatePhoneNumber,
            handleWebappListPageChange, handleWebappRequestModal
        } = this;
        const { changeAuth, changePass, couponList, businessFile, changeCate, phoneRegister, phoneListModal, phoneUpdateModal, webappListModal, webappRequestModal, withdrawModal, marketingAgreeHistory, TID } = this.state;

        const { alertOpen, alertMessage, alertButtons } = this.state;
        const { closeAlert, ajaxPostPhoneReady } = this;

        return (
            <>
                <Loading loading={loading} />
                <div className="container-xxl mypage-settings">
                    <header className="mypage-heading">
                        <h1>마이페이지</h1>
                    </header>

                    <div className="mypage-panel">
                        <div className="mypage-profile">
                            <img className="mypage-avatar"
                                src={user.profileImgLink != null ? user.profileImgLink : '/assets/img/account_box.png'}
                                alt="업체 프로필 이미지" />
                            <div className="mypage-profile-info">
                                <h2>{user.comName ? user.comName : ''}</h2>
                            </div>
                            <input type="file" accept="image/*" style={{ display: 'none' }}
                                ref={(input) => this.fileInput = input}
                                onChange={this.ajaxPostProfileImage} />
                            <button type="button" className="btn mypage-btn-secondary mypage-profile-action"
                                onClick={() => this.fileInput.click()}>
                                프로필 이미지 {user && user.profileImgLink ? '수정' : '등록'}
                            </button>
                        </div>

                        <section className="mypage-section" aria-labelledby="mypage-basic-title">
                            <div className="mypage-section-heading">
                                <h2 id="mypage-basic-title">기본 정보</h2>
                            </div>
                            <div className="mypage-section-content">
                                <dl className="mypage-details">
                                    <div className="mypage-detail-row">
                                        <dt>담당자명</dt>
                                        <dd>{user.name ? user.name : ''}</dd>
                                    </div>
                                    <div className="mypage-detail-row">
                                        <dt>담당자 연락처</dt>
                                        <dd>{user.phone ? stringUtil.formatPhone(user.phone) : ''}</dd>
                                    </div>
                                    {user.siteid && !user.useSync === 'Y'
                                        ? (<div className="mypage-detail-row">
                                            <dt>담당자 이메일</dt>
                                            <dd>{user.email ? user.email : ''}</dd>
                                        </div>)
                                        : null
                                    }
                                    <div className="mypage-detail-row">
                                        <dt>업체 이용 계정</dt>
                                        <dd className="mypage-login-account">
                                            {user.siteid && user.useSync === 'Y'
                                                ? <React.Fragment>
                                                    {user.syncType === 'KAKAO' &&
                                                        <React.Fragment>
                                                            <img src="/assets/img/kakao_icon.png" alt="카카오톡" />
                                                            <span>{user.email}</span>
                                                        </React.Fragment>
                                                    }
                                                    {user.syncType === 'NAVER' &&
                                                        <React.Fragment>
                                                            <img src="/assets/img/naver_icon.png" alt="네이버" />
                                                            <span>{user.email}</span>
                                                        </React.Fragment>
                                                    }
                                                </React.Fragment>
                                                : (user.siteid ? user.siteid : '')
                                            }
                                        </dd>
                                    </div>
                                    <div className="mypage-detail-row">
                                        <dt>사업자 등록증</dt>
                                        <dd>
                                            <button type="button" className="btn mypage-btn-secondary"
                                                onClick={() => this.toggleModal('businessFile', true)}>사업자 등록증 보기</button>
                                        </dd>
                                    </div>
                                    <div className="mypage-detail-row">
                                        <dt>타겟팅 희망 카테고리</dt>
                                        <dd className="mypage-value-actions">
                                            <span>{user.mainCategoryName ? user.mainCategoryName + ' > ' + user.midCategoryName + ' > ' + user.subCategoryName : ''}</span>
                                            <button type="button" className="btn btn-primary" onClick={ajaxPostPhoneReady}>카테고리 수정</button>
                                        </dd>
                                    </div>
                                </dl>
                                <div className="mypage-section-actions">
                                    <button type="button" className="btn mypage-btn-secondary"
                                    onClick={() => this.openAlert(
                                        "담당자 변경을 원하시면 가입 시 등록한 사업자 등록증과 함께 1:1 문의로 변경 요청 부탁드립니다.",
                                        [{
                                            onClick: function () {
                                                closeAlert()
                                            }, label: "확인", className: "btn btn-primary"
                                        }]
                                    )}>
                                        담당자 정보 변경
                                    </button>
                                </div>
                            </div>
                        </section>

                        <section className="mypage-section" aria-labelledby="mypage-usage-title">
                            <div className="mypage-section-heading">
                                <h2 id="mypage-usage-title">이용 현황</h2>
                            </div>
                            <div className="mypage-section-content">
                                <dl className="mypage-usage">
                                    <div><dt>총 발송 건수</dt><dd>{user.totalSendCnt != null ? stringUtil.formatNumber(user.totalSendCnt) : ''}<span>건</span></dd></div>
                                    <div><dt>평균 반응률</dt><dd>{user.reactRate != null ? user.reactRate : ''}<span>%</span></dd></div>
                                    <div><dt>보유 무료 건수</dt><dd>0<span>건</span></dd></div>
                                    <div><dt>보유 쿠폰</dt><dd><button type="button" className="btn mypage-btn-secondary"
                                        onClick={() => this.toggleModal('couponList', true)}>쿠폰 보기</button></dd></div>
                                </dl>
                            </div>
                        </section>

                        <section className="mypage-section mypage-consent-section" aria-labelledby="mypage-consent-title">
                            <div className="mypage-section-heading">
                                <h2 id="mypage-consent-title">마케팅 수신 동의</h2>
                                <button type="button" className="btn mypage-btn-secondary"
                                    onClick={() => this.toggleModal('marketingAgreeHistory', true)}>동의 이력</button>
                            </div>
                            <div className="mypage-section-content mypage-consents">
                                <div className="mypage-consent-row" role="group" aria-labelledby="mypage-mms-label">
                                    <span className="mypage-channel" id="mypage-mms-label">문자</span>
                                    <div className="mypage-consent-control">
                                        <RadioBtnList id="agreeRecvMms" list={agreement} value={user.agreeRecvMms} onChange={setValue} />
                                        <div className="mypage-consent-dates"><span>{user.agreeRecvMms === 'Y' ? '동의일자' : '철회일자'} <time>{(user.agreeRecvMms === 'Y' ? user.mmsAgreedAt : user.mmsRevokedAt) || '-'}</time></span></div>
                                    </div>
                                </div>
                                <div className="mypage-consent-row" role="group" aria-labelledby="mypage-mail-label">
                                    <span className="mypage-channel" id="mypage-mail-label">이메일</span>
                                    <div className="mypage-consent-control">
                                        <RadioBtnList id="agreeRecvMail" list={agreement} value={user.agreeRecvMail} onChange={setValue} />
                                        <div className="mypage-consent-dates"><span>{user.agreeRecvMail === 'Y' ? '동의일자' : '철회일자'} <time>{(user.agreeRecvMail === 'Y' ? user.mailAgreedAt : user.mailRevokedAt) || '-'}</time></span></div>
                                    </div>
                                </div>
                                <div className="mypage-consent-row" role="group" aria-labelledby="mypage-kakao-label">
                                    <span className="mypage-channel" id="mypage-kakao-label">카카오톡</span>
                                    <div className="mypage-consent-control">
                                        <RadioBtnList id="agreeRecvKakao" list={agreement} value={user.agreeRecvKakao || 'N'} onChange={setValue} />
                                        <div className="mypage-consent-dates"><span>{user.agreeRecvKakao === 'Y' ? '동의일자' : '철회일자'} <time>{(user.agreeRecvKakao === 'Y' ? user.kakaoAgreedAt : user.kakaoRevokedAt) || '-'}</time></span></div>
                                    </div>
                                </div>
                            </div>
                        </section>

                        <section className="mypage-section" aria-labelledby="mypage-registration-title">
                            <div className="mypage-section-heading">
                                <h2 id="mypage-registration-title">등록 정보 관리</h2>
                            </div>
                            <div className="mypage-section-content">
                                <div className="mypage-management-row">
                                    <span>웹/앱 등록 요청 내역</span>
                                    <div className="mypage-button-group">
                                        <button type="button" className="btn btn-primary" onClick={handleWebappRequestModal}>등록</button>
                                        <button type="button" className="btn mypage-btn-secondary" onClick={() => this.toggleModal('webappListModal', true)}>목록 보기</button>
                                    </div>
                                </div>
                                <div className="mypage-management-row">
                                    <span>전화번호 등록</span>
                                    <div className="mypage-button-group">
                                        <button type="button" className="btn btn-primary" onClick={() => this.toggleModal('phoneRegister', true)}>등록</button>
                                        <button type="button" className="btn mypage-btn-secondary" onClick={() => this.toggleModal('phoneListModal', true)}>목록 보기</button>
                                    </div>
                                </div>
                            </div>
                        </section>

                        <section className="mypage-section" aria-labelledby="mypage-account-title">
                            <div className="mypage-section-heading">
                                <h2 id="mypage-account-title">계정 관리</h2>
                            </div>
                            <div className="mypage-section-content mypage-account-actions">
                                {user.useSync !== 'Y' &&
                                    <button type="button" className="btn mypage-btn-secondary"
                                        onClick={() => this.toggleModal('changePass', true)}>비밀번호 변경</button>
                                }
                                <button type="button" className="btn mypage-btn-withdraw"
                                    onClick={() => this.toggleModal('withdrawModal', true)}>회원 탈퇴</button>
                            </div>
                        </section>
                    </div>
                </div>

                <BussinessFileModal
                    isOpen={businessFile}
                    onRequestClose={() => this.toggleModal('businessFile', false)}
                    comRegistImgLink={user ? user.comRegistImgLink : ''}
                />
                <CouponListModal
                    isOpen={couponList}
                    onRequestClose={() => this.toggleModal('couponList', false)}
                    coupons={coupons}
                />
                <MarketingAgreeHistoryModal
                    isOpen={marketingAgreeHistory}
                    onRequestClose={() => this.toggleModal('marketingAgreeHistory', false)}
                />
                <AuthToChangeInfoModal
                    isOpen={changeAuth}
                    onRequestClose={() => this.toggleModal('changeAuth', false)}
                    openChangeCate={() => this.toggleModal('changeCate', true)}
                />
                <UpdateCateModal
                    isOpen={changeCate}
                    isClose={() => {
                        this.toggleModal('changeCate', false);
                        this.ajaxGetUserInfo();
                    }}
                />
                {
                    user.useSync !== 'Y' &&
                    <ChangePasswordModal
                        isOpen={changePass}
                        onRequestClose={() => this.toggleModal('changePass', false)}
                    />
                }
                <Alert
                    isOpen={alertOpen}
                    handleClose={closeAlert}
                    message={alertMessage}
                    buttons={alertButtons}
                />
                <PhoneRegisterModal
                    isOpen={phoneRegister}
                    onRequestClose={() => this.toggleModal('phoneRegister', false)}
                    setValue={setPhoneRegisterInfo}
                    phoneName={phoneRegisterName}
                    phoneList={phoneRegisterList}
                    registerAction={ajaxRegisterPhoneNumber}
                />
                <PhoneUpdateModal
                    isOpen={phoneUpdateModal}
                    onRequestClose={() => this.toggleModal('phoneUpdateModal', false)}
                    setValue={setPhoneRegisterInfo}
                    uid={phoneUid}
                    phoneName={phoneRegisterName}
                    phoneList={phoneRegisterList}
                    updateAction={ajaxUpdatePhoneNumber}
                />
                <PhoneListModal
                    isOpen={phoneListModal}
                    onRequestClose={() => this.toggleModal('phoneListModal', false)}
                    page={phoneListPage}
                    size={phoneListSize}
                    total={phoneListTotal}
                    list={phoneList}
                    handlePageChange={handlePhoneListPageChange}
                    openUpdateModal={() => this.toggleModal('phoneUpdateModal', true)}
                    selectAction={ajaxGetPhoneNumberForUpdate}
                    deleteAction={ajaxDeletePhoneNumber}
                />
                <AppRequestListModal
                    isOpen={webappListModal}
                    onRequestClose={() => this.toggleModal('webappListModal', false)}
                    page={webappListPage}
                    size={webappListSize}
                    total={webappListTotal}
                    list={webappList}
                    handlePageChange={handleWebappListPageChange}
                />
                <AppRequestModal
                    isOpen={webappRequestModal}
                    handleClose={handleWebappRequestModal}
                />
                <WithdrawModal
                    isOpen={withdrawModal}
                    loading={loading}
                    onRequestClose={() => this.toggleModal('withdrawModal', false)}
                    onSubmit={this.ajaxWithdraw}
                />
                <form id={"authForm"} className={"visually-hidden"}
                    action="https://wauth.teledit.com/Danal/WebAuth/Web/Start.php" method="POST">
                    <input name={"TID"} type="text" value={TID} readOnly={true} />
                    <input name={"BgColor"} type="text" value={"00"} readOnly={true} />
                    <input name={"IsCharSet"} type="text" value={"UTF-8"} readOnly={true} />
                    <button className={"btn btn-primary"} type={"submit"}>submit</button>
                </form>
            </>
        )
    }// end render
}// end class

export default connect(
    (state) => ({
        user: state.myInfo.get('user'),
        rivalCompanyUrls: state.myInfo.get('rivalCompanyUrls'),
        inputRivalCompanyUrl: state.myInfo.get('inputRivalCompanyUrl'),
        coupons: state.myInfo.get('coupons'),
        phoneRegisterName: state.myInfo.get('phoneRegisterName'),
        phoneRegisterList: state.myInfo.get('phoneRegisterList'),
        phoneListPage: state.myInfo.get('phoneListPage'),
        phoneListSize: state.myInfo.get('phoneListSize'),
        phoneListTotal: state.myInfo.get('phoneListTotal'),
        phoneList: state.myInfo.get('phoneList'),
        phoneUid: state.myInfo.get('phoneUid'),
        webappListPage: state.myInfo.get('webappListPage'),
        webappListSize: state.myInfo.get('webappListSize'),
        webappListTotal: state.myInfo.get('webappListTotal'),
        webappList: state.myInfo.get('webappList'),
    }),
    (dispatch) => ({
        MyInfoAction: bindActionCreators(myInfoAction, dispatch),
    })
)(MyPageContainer);
